import axios from 'axios';
import { Left, Right } from '../../../../shared/core/either';
import { Result } from '../../../../shared/core/result';
import { Mode, planIdUrl, plansUrl } from '../../../../shared/helpers/endPoints';
import { getStoreLocal } from '../../../../shared/helpers/utils';
import { APIResponse } from '../../../../shared/infrastructure/services/api.response';
import { authService } from '../../../users/services/dependency.injection';
import { BasePlanService } from './base_plan.service';
import { IPlanContent, IPlans } from '../../models/plans/plans.model';

export class PlanService implements BasePlanService {
    async getPlans(values: any): Promise<APIResponse<IPlans>> {
        const modeType = getStoreLocal('modeType') as Mode;
        try {
            const response = await axios({
                method: 'GET',
                url: plansUrl(modeType),
                params: { ...values },
                headers: {
                    Authorization: `Bearer ${authService.accessToken()}`,
                    'Content-Type': 'application/json'
                }
            });

            return new Right(Result.ok<IPlans>(response.data));
        } catch (error: any) {
            const errorMessage =
                error?.data?.error?.message !== undefined ? error?.data?.error?.message : 'something went wrong';
            return new Left(errorMessage);
        }
    }

    async getPlanById(planId: string): Promise<APIResponse<IPlanContent>> {
        const modeType = getStoreLocal('modeType') as Mode;

        try {
            const response = await axios({
                method: 'GET',
                url: planIdUrl(modeType, planId),
                headers: {
                    Authorization: `Bearer ${authService.accessToken()}`
                }
            });

            return new Right(Result.ok<IPlanContent>(response.data));
        } catch (error) {
            const errorMessage =
                error?.data?.error?.message !== undefined ? error.data.error.message : 'something went wrong';
            return new Left(errorMessage);
        }
    }

    async createPlan(value: any): Promise<APIResponse<IPlanContent>> {
        const modeType = getStoreLocal('modeType') as Mode;
        try {
            const response = await axios({
                method: 'POST',
                url: plansUrl(modeType),
                data: { ...value },
                params: null,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authService.accessToken()}`
                }
            });

            return new Right(Result.ok<IPlanContent>(response.data));
        } catch (error: any) {
            const errorMessage =
                error?.data?.error?.message !== undefined ? error.data.error.message : 'something went wrong';

            return new Left(errorMessage);
        }
    }

    async updatePlan({ planId, values }: any): Promise<APIResponse<IPlanContent>> {
        const modeType = getStoreLocal('modeType') as Mode;
        try {
            const response = await axios({
                method: 'POST',
                url: planIdUrl(modeType, planId),
                data: { ...values },
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authService.accessToken()}`
                }
            });

            return new Right(Result.ok<IPlanContent>(response.data));
        } catch (error: any) {
            return new Left(
                error?.data?.error?.message !== undefined ? error?.data?.error?.message : 'something went wrong'
            );
        }
    }

    async deletePlan(planId: any): Promise<APIResponse<any>> {
        const modeType = getStoreLocal('modeType') as Mode;

        try {
            await axios({
                method: 'DELETE',
                url: planIdUrl(modeType, planId),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authService.accessToken()}`
                }
            });

            return new Right(Result.ok());
        } catch (error: any) {
            return new Left(
                error?.data?.error?.message !== undefined ? error?.data?.error?.message : 'something went wrong'
            );
        }
    }
}
